<template>
    <div id="verificationCode">
        <div class="cover" v-if="visible">
            <div class="cover_panel">
                <div class="panel_text">您的手机号为{{formatPhone}}，请获取并输入验证码，验证成功后方可进入“服务”</div>
                <button class="get_code" @click="sendCode" :disabled="!!leftTime">{{ btnText }}</button>
                <div class="code_group">
                    <input type="tel"
                    ref="codeInput"
                    v-for="(num,index) in code" 
                    :key="index" 
                    class="code_input"
                    v-model="num.number"
                    @keyup.delete="backspace(index)" 
                    @input="inputCode(index)"
                    :maxlength="index == 0 ? 6 : 1" 
                    :disabled="num.isDisabled">
                </div>
                <div class="panel_tips">请输入验证码</div>
                <div class="panel_bottom">
                    <button :disabled="!code[5].number" @click="verificationCode" class="panel_bottom_btn confirm">确定</button>
                    <button @click="closeCover" class="panel_bottom_btn cancel">取消</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import { time } from 'echarts';
    export default {
        data() {
            return {
                leftTime:0,
                code:[
                    {number:"",isDisabled:false},
                    {number:"",isDisabled:true},
                    {number:"",isDisabled:true},
                    {number:"",isDisabled:true},
                    {number:"",isDisabled:true},
                    {number:"",isDisabled:true},
                ],
                timer:null
            }
        },
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            phoneNumber:{
                type:String,
                default:"15036536683"
            }
        },
        created() {
        
        },
        computed:{
            formatPhone(){
                let phoneStr = String(this.phoneNumber);
                let phoneArr = phoneStr.split("");
                phoneArr.splice(3,4,"****");
                return phoneArr.join("");
            },
            btnText(){
                return this.leftTime == 0 ? "获取验证码" : this.leftTime + "s后可再次点击"
            }
        },
        mounted(){
            
        },
        watch:{
            visible(val){
                if(val){
                    this.$nextTick(()=>{
                        this.$refs.codeInput[0].focus();
                    })
                }else{
                    this.code=[
                        {number:"",isDisabled:false},
                        {number:"",isDisabled:true},
                        {number:"",isDisabled:true},
                        {number:"",isDisabled:true},
                        {number:"",isDisabled:true},
                        {number:"",isDisabled:true},
                    ]
                }
            }
        },
        methods: {
            backspace(index){
                if (index === 0) return; //删除键，判断是不是第一个入框
                this.code[index].isDisabled = true; //如果不是，关闭当前删除数字的输入框
                this.code[index].number = ""; //如果不是，关闭当前删除数字的输入框
                this.code[index - 1].isDisabled = false;//允许前个输入框输入，并获取光标
                this.code[index - 1].number = "";//清空个输入框
                this.$nextTick(()=>{
                    this.$refs.codeInput[index - 1].focus();
                })
            },
            inputCode(index){
                let num = this.code[index].number;
                if (num.length > 1){ //如果复制验证码大于1位
                    this.copyNum(num);
                } else {
                    if (isNaN(num)) { //判断是不是数字
                        this.code[index].number = "";//如果不是数字，清空
                        return;
                    }
                    if (index < 5){
                        this.code[index].isDisabled = true; //输入了数字，当前的输入框变成不可再输入
                        this.code[index + 1].isDisabled = false; //如果不是最后一个输入框
                        this.$nextTick(()=>{
                            this.$refs.codeInput[index + 1].focus();//下一个输入框，获取光标
                        })
                    }
                }
            },
            copyNum(num){
                for (let i = 0; i < num.length; i++) {
                    if(isNaN(num[i])){ //如果复制的不是数字
                        code[i].number='' //清空当前新入旗
                        break
                    }
                    if (i > 5) break; //如果大于六个数字，跳出循环
                    this.code[i].number = num[i]; //把当前的数字分配到对应的输入想
                    if (i < 5){ //如果数字长度，在6个之内
                        this.code[i].isDisabled = true; //能填到数字的入框不能静入
                        this.code[i + 1].isDisabled = false; //打开下一个新入框,
                        this.$nextTick(()=>{
                            this.$refs.codeInput[i + 1].focus();//下一个输入框，获取光标
                        })
                    }
                }
            },
            sendCode(){
                this.leftTime = 60;
                this.timer = setInterval(()=>{
                    console.log(this.timer)
                    this.leftTime--
                    if(this.leftTime == 0){
                        clearInterval(this.timer);
                    }
                },1000)
                this.$http.post(API_URL_BASE_API+"/sms/send_code/",{
                    phone:this.phoneNumber,
                    place_id:119,
                    code_type:4
                }).then((res)=>{
                    res = res.data
                    if(res.response != "ok"){
                        clearInterval(this.timer);
                        layer.tips(res.message);
                    }
                }).catch((res)=>{
                    clearInterval(this.timer);
                    layer.tips("服务器繁忙，请重新发送");
                })
            },
            verificationCode(){
                let code = this.code.map(c=>c.number).join("");
                this.$http.post(API_URL_BASE_API+"/sms/verify_code/",{
                    phone:this.phoneNumber,
                    place_id:119,
                    code_type:4,
                    code
                }).then((res)=>{
                    res = res.data
                    if(res.response == "ok"){
                        this.$emit("success")
                    }else{
                        layer.tips(res.message);
                    }
                })
            },
            closeCover(){
                this.$emit('update:visible',false)
                this.$emit('close',false)
            }
        },
        destroyed(){
            if(this.timer) clearInterval(this.timer);
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #verificationCode{
        .cover{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.6);
            z-index: 100;
            .cover_panel{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 592px/$ppr;
                background-color: #fff;
                border-radius: 10px/$ppr;
                padding: 46px/$ppr 48px/$ppr 60px/$ppr;
                box-sizing: border-box;
                .panel_text{
                    text-align: center;
                    font-size: 28px/$ppr;
                    line-height: 44px/$ppr;
                }
                .get_code{
                    display: block;
                    width: 200px/$ppr;
                    height: 100px/$ppr;
                    margin: 0 auto 8px/$ppr;
                    background-color: transparent;
                    border: none;
                    font-size: 24px/$ppr;
                    color: #5e89ef;
                    &:disabled{
                        color: #999;
                    }
                }
                .code_group{
                    display: flex;
                    justify-content: space-between;
                    .code_input{
                        width: 68px/$ppr;
                        height: 68px/$ppr;
                        text-align: center;
                        display: block;
                        font-size: 40px/$ppr;
                        font-weight: bold;
                        border: 1px solid #f7af31;
                        color: #111;
                        border-radius: 4px/$ppr;
                        background-color: #fff;
                        &:disabled{
                            border-color: #cdcdcd;
                        }
                    }
                }
                .panel_tips{
                    font-size: 24px/$ppr;
                    color: #f60;
                    text-align: center;
                    padding: 30px/$ppr 0 76px/$ppr;
                    line-height: 42px/$ppr;
                }
                .panel_bottom{
                    display: flex;
                    justify-content: space-between;
                    padding: 0 12px/$ppr;
                    .panel_bottom_btn{
                        width: 220px/$ppr;
                        height: 72px/$ppr;
                        border: none;
                        border-radius: 8px/$ppr;
                        color: #fff;
                        font-size: 28px/$ppr;
                        &.confirm{
                            background-color: #5e89ef;
                        }
                        &.cancel{
                            background-color: #ccc;
                        }
                    }
                }
            }
        }
    }
    input:disabled,
    input[disabled] {
        -webkit-text-fill-color: #111;
        opacity: 1;
    }
    input{-webkit-appearance: none; }
</style>